import { commonCs } from './common';
import { authCs } from './auth';
import { navigationCs } from './navigation';
import { appCs } from './app';
import { settingsCs } from './settings';
import { errorsCs } from './errors';

export const csCatalog = {
  ...commonCs,
  ...authCs,
  ...navigationCs,
  ...appCs,
  ...settingsCs,
  ...errorsCs,
};
